import { render, staticRenderFns } from "./comp_menu_lang.vue?vue&type=template&id=6ca530a0&"
import script from "./comp_menu_lang.vue?vue&type=script&lang=js&"
export * from "./comp_menu_lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports